<template>
  <a-modal
    title="插班"
    :maskClosable="false"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @cancel="handleCancel"
    @ok="handleSubmit"
    :destroyOnClose="true"
  >
    <div class="class-list">
      <!-- 搜索 -->
      <div class="search-inner">
        <a-form layout="inline">
          <a-form-item class="name" label="ID">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentId"
            ></a-input>
          </a-form-item>
          <a-form-item class="name" label="学生名称">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentName"
            ></a-input>
          </a-form-item>

          <a-form-item class="name" label="学号">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              v-model="queryParam.studentNumber"
            ></a-input>
          </a-form-item>
          <a-form-item class="name" label="班级">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.classId"
            >
              <a-select-option
                v-for="(item, index) in classList"
                :key="index"
                :value="item.id"
                >{{ item.className }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="年级">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.gradeId"
            >
              <a-select-option
                v-for="(item, index) in $store.getters.getGradeScope"
                :key="index"
                :value="item.id"
                >{{ item.tagName }}</a-select-option
              >
            </a-select>
          </a-form-item>

          <a-form-item class="search-oper">
            <a-button class="search" type="primary" @click="searchStudent()"
              >查询</a-button
            >
            <a-button type="primary" @click="() => (queryParam = {})"
              >重置</a-button
            >
          </a-form-item>
        </a-form>
      </div>
      <!-- 表格数据 -->
      <a-table
        :columns="columns"
        :dataSource="studentList"
        :pagination="pagination"
        :loading="loading"
        @change="tableChange"
        :row-selection="{ onChange: onSelectChange }"
      >
        <span slot="gradeId" slot-scope="text, record">
          <template>
            <span>{{ record.gradeId | gradeScopeFilter }}</span>
          </template>
        </span>
        <span slot="gender" slot-scope="text, record">
          <template>
            <span>{{ record.gender | gender }}</span>
          </template>
        </span>
      </a-table>
    </div>
    <a-modal
      :closable="false"
      title="未查询到的学生或学号"
      :maskClosable="false"
      :width="400"
      :visible="barrenVisible"
      :confirmLoading="confirmLoading"
    >
      <template slot="footer">
        <a-button type="primary" key="back" @click="barrenVisible = false">
          确定
        </a-button>
      </template>
      <span v-for="(item, index) in barrenList" :key="index">{{ item }}</span>
    </a-modal>
  </a-modal>
</template>

<script>
import student from '../../../api/student'

import classSet from '../../../api/classSet'

import sourceClass from '../../../api/sourceClass'

import moment from 'moment'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 60,
  },
  {
    title: '学生名称',
    dataIndex: 'studentName',
    width: 90,
  },
  {
    title: '性别',
    dataIndex: 'gender',
    scopedSlots: { customRender: 'gender' },
    width: 50,
  },
  {
    title: '生日',
    dataIndex: 'birthday',
  },
  {
    title: '学号',
    dataIndex: 'studentNumber',
  },
  {
    title: '年级',
    dataIndex: 'gradeId',
    scopedSlots: { customRender: 'gradeId' },
    width: 80,
  },
  {
    title: '原始班级',
    dataIndex: 'className',
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    sorter: (a, b) =>
      new Date(a.gmtCreate).getTime() - new Date(b.gmtCreate).getTime(),
  },
]
export default {
  name: 'insertClass',
  data() {
    return {
      moment,
      columns, //列标识数据
      visible: false,
      confirmLoading: false,
      studentList: [], //学生列表
      selectedStudent: [], //选中的行
      classId: '', //班级ID
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        current: 1,
        pageSize: 100,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        showLessItems: true,
        showSizeChanger: true,
      }, //分页数据对象
      loading: true,
      queryParam: {}, //查询参数
      classList: [], //班级列表
      barrenVisible: false, //批量插班，弹框
      barrenList: [],
    }
  },
  methods: {
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = this.queryParam
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getClassList(obj)
    },

    //提交
    handleSubmit() {
      if (this.selectedStudent.length == 0) {
        this.$message.warn('请选择学生')
        return
      }
      let req = {
        classId: this.classId,
        studentIds: this.selectedStudent.join(),
      }
      classSet.joinClass(req).then((res) => {
        this.$message.success('插班成功')
        this.$emit('refreshList', res.data)
        this.handleCancel()
      })
    },

    //table选中事件
    onSelectChange(selectedRowKeys, value) {
      this.selectedStudent = []
      value.map((item) => {
        this.selectedStudent.push(item.id)
      })
    },

    //初始化，显示
    init(id) {
      this.visible = true
      this.classId = id
      this.getClassList()

      //下拉班级列表
      sourceClass.selectSearch().then((res) => {
        this.classList = res.data
      })
    },

    //隐藏
    handleCancel() {
      this.pagination.pageSize = 100
      this.visible = false
      this.$emit('closeForm')
    },

    //查询学生
    searchStudent() {
      // if (
      //   this.queryParam.studentId &&
      //   !/^[0-9]*$/.test(this.queryParam.studentId)
      // ) {
      //   this.$message.error('ID仅限输入数字')
      //   return
      // }
      this.pagination.pageSize = 100
      this.queryParam.currentPage = 1
      this.getClassList(this.queryParam)
    },

    //获取班级列表
    getClassList(req = {}) {
      //学号，和姓名不能多于50个
      const { studentName = '', studentNumber = '' } = this.queryParam
      if (
        studentName.split(' ').length > 50 ||
        studentNumber.split(' ').length > 50
      ) {
        this.$message.warn('查询数量不得多于50个')
        return
      }

      if (this.$store.getters.schoolId) {
        req.schoolId = this.$store.getters.schoolId
      }
      this.loading = true
      console.log('req', req)
      student
        .getStudentList({
          ...req,
          studentName: studentName.trim(),
          ...this.pagination,
        })
        .then((res) => {
          console.log('res', res)
          if (res.data.noSearchStudentNameOrNumber) {
            this.barrenVisible = true
            this.barrenList = res.data.noSearchStudentNameOrNumber
          }
          this.studentList = res.data.list
          this.loading = false
          //分页信息
          // this.pagination = res.data.pagination;
          const total = res.data.pagination.total
          this.pagination.total = total
          if (
            total > 10000 &&
            !this.pagination.pageSizeOptions.includes('120')
          ) {
            this.pagination.pageSizeOptions = [
              ...this.pagination.pageSizeOptions,
              '120',
              '150',
            ]
          }
          if (
            res.data.pagination.total > 100000 &&
            !this.pagination.pageSizeOptions.includes('200')
          ) {
            this.pagination.pageSizeOptions.push('200')
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.class-list {
  height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: hidden;
  .oper {
    text-align: right;
    margin-bottom: 10px;
    > .export {
      margin-left: 10px;
    }
  }
}
.class-cell {
  font-size: 14px;
  color: $normal-color-dark;
  line-height: 26px;
}
.tab-active {
  color: $primary-color;
}
.tab-list {
  border-bottom: 1px solid $border-color;
  padding: 0px 0px 10px;
  margin-bottom: 20px;
  > .tab {
    display: inline-block;
    margin-right: 30px;
    font-size: 16px;
  }
}
.search-inner {
  margin-bottom: 10px;
}
.search-oper {
  .search {
    margin-right: 10px;
  }
}
</style>
